function initCollectionTabs() {
  const collectionTitles = document.querySelectorAll(".collection_titles");

  if (!collectionTitles.length) return;

  const firstTitleId = collectionTitles[0].getAttribute("data-collection-id");
  collectionTitles[0].classList.add("active");

  const firstCollectionDiv =
    document.querySelector(
      `.featured__collection[data-collection-id="${firstTitleId}"]`
    ) ||
    document.querySelector(
      `.featured__collection-carousel[data-collection-id="${firstTitleId}"]`
    );
  if (firstCollectionDiv) {
    firstCollectionDiv.classList.add("active");
  }

  collectionTitles.forEach((title) => {
    title.addEventListener("click", function () {
      const collectionId = this.getAttribute("data-collection-id");

      collectionTitles.forEach((t) => t.classList.remove("active"));

      const allCollectionDivs = document.querySelectorAll(
        ".featured__collection, .featured__collection-carousel"
      );
      allCollectionDivs.forEach((div) => div.classList.remove("active"));

      this.classList.add("active");

      const collectionDiv =
        document.querySelector(
          `.featured__collection[data-collection-id="${collectionId}"]`
        ) ||
        document.querySelector(
          `.featured__collection-carousel[data-collection-id="${collectionId}"]`
        );
      if (collectionDiv) {
        collectionDiv.classList.add("active");

        if (collectionDiv.classList.contains("js-carousel")) {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 50);
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initCollectionTabs);

document.addEventListener("shopify:section:load", initCollectionTabs);
